let messaages_it = {
	Salutation: {
		required: 'Seleziona un saluto.',
	},
	FirstName: {
		required: 'Inserisci un nome.',
	},
	LastName: {
		required: 'Inserisci un cognome.',
	},
	Email: {
		required: 'Inserisci un indirizzo email.',
		email: 'Inserisci un indirizzo email valido.',
	},
	Country: {
		required: 'Seleziona un paese.',
	},
	Postcode: {
		required: 'Seleziona un codice postale.',
	},
	Password: {
		required: 'Inserisci una password.',
	},
	ConfirmPassword: {
		required: 'Inserisci una password per confermarlo.',
		equalTo: 'Assicurati che le password corrispondano.',
	},
	TermsAndConditions: {
		required: 'Si prega di accettare i termini e le condizioni.',
	}
};

export function messages_it() {
	return messaages_it;
}
